import React, { useState } from "react";
import GlobalStyles, { CommonClasses } from "../../global/GlobalStyle";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";
import DarkModeToggle from "../darkMode/DarkModeToggle";
import { useAuth } from "../../hooks/useAuth";

const menuItems = [
  { name: "Home", link: "/" },
  { name: "About", link: "/about" },
  { name: "Privacy", link: "/privacy" },
  { name: "T & C", link: "/terms" },
];

const GuestNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    setIsOpen(false);
  };

  return (
    <nav
      className={`w-full h-16 fixed z-50 bg-lightBackground dark:bg-darkBackground ${CommonClasses.transition}`}
    >
      <div
        className={`w-full h-full relative px-5 lg:px-8 ${CommonClasses.flexBetween}`}
      >
        {/* Logo */}
        <Link to={isAuthenticated ? "/dashboard" : "/"}>
          <img src={logo} alt="Logo" className="w-16 h-16" />
        </Link>

        {/* Desktop Menu */}
        <div className={`${CommonClasses.flexCenter} gap-5 hidden lg:flex`}>
          {menuItems.map((item, index) => (
            <Link to={item.link} key={index} className={`${GlobalStyles.link}`}>
              {item.name}
            </Link>
          ))}
        </div>

        {/* Desktop Buttons */}
        <div className={`${CommonClasses.flexCenter} gap-5 hidden lg:flex`}>
          <DarkModeToggle />
          {isAuthenticated ? (
            <>
              <Link
                to="/dashboard"
                className={`${GlobalStyles.buttonPrimary} !w-28`}
              >
                Dashboard
              </Link>
              <button
                onClick={handleLogout}
                className={`${GlobalStyles.buttonOutline} !w-28`}
              >
                Logout
              </button>
              {user?.role === "admin" && (
                <Link
                  to="/admin"
                  className={`${GlobalStyles.buttonSecondary} !w-28`}
                >
                  Admin
                </Link>
              )}
            </>
          ) : (
            <>
              <Link
                to={"/login"}
                className={`${GlobalStyles.buttonOutline} !w-28`}
              >
                Login
              </Link>
              <Link
                to={"/register"}
                className={`${GlobalStyles.buttonPrimary} !w-28`}
              >
                Signup
              </Link>
            </>
          )}
        </div>
        <div className={`${CommonClasses.flexCenter} gap-5 lg:hidden flex`}>
          <DarkModeToggle />
          {/* Mobile Hamburger */}
          <button
            className={`flex flex-col justify-between w-8 ${
              isOpen ? "h-5" : "h-6"
            } cursor-pointer relative ${CommonClasses.transition}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span
              className={`block w-full h-0.5 bg-primary transition-all duration-300 ${
                isOpen ? "rotate-45 translate-y-2" : ""
              }`}
            ></span>
            <span
              className={`block w-full h-0.5 bg-primary transition-all duration-300 ${
                isOpen ? "opacity-0" : ""
              }`}
            ></span>
            <span
              className={`block w-full h-0.5 bg-primary transition-all duration-300 ${
                isOpen ? "-rotate-45 -translate-y-2" : ""
              }`}
            ></span>
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      <div
        className={`lg:hidden absolute top-16 left-0 w-full bg-lightBackground dark:bg-darkBackground  transition-all duration-300 overflow-hidden ${
          isOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <div className="flex flex-col px-5 py-3 space-y-3">
          {menuItems.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              onClick={() => setIsOpen(false)}
              className={`${CommonClasses.transition} text-sm py-2 text-center text-primary hover:text-secondary`}
            >
              {item.name}
            </Link>
          ))}
          <div className="flex flex-col gap-3 mt-2">
            {isAuthenticated ? (
              <>
                <Link
                  to="/dashboard"
                  onClick={() => setIsOpen(false)}
                  className={`${GlobalStyles.buttonPrimary} !w-full`}
                >
                  Dashboard
                </Link>
                {user?.role === "admin" && (
                  <Link
                    to="/admin"
                    onClick={() => setIsOpen(false)}
                    className={`${GlobalStyles.buttonSecondary} !w-full`}
                  >
                    Admin
                  </Link>
                )}
                <button
                  onClick={handleLogout}
                  className={`${GlobalStyles.buttonOutline} !w-full`}
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to={"/login"}
                  onClick={() => setIsOpen(false)}
                  className={`${GlobalStyles.buttonPrimary} !w-full`}
                >
                  Login
                </Link>
                <Link
                  to={"/register"}
                  onClick={() => setIsOpen(false)}
                  className={`${GlobalStyles.buttonSecondary} !w-full`}
                >
                  Signup
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default GuestNavbar;
